const SessionStorage = {
  get: itemName => {
    const item = sessionStorage.getItem(itemName);
    const numPattern = new RegExp(/^\d+$/);

    // eslint-disable-next-line
    const jsonPattern = new RegExp(/[\[{].*[\}\]]/);

    if (typeof item === undefined || typeof item === null) {
      return null;
    }

    if (jsonPattern.test(item)) {
      return JSON.parse(item);
    }
    if (numPattern.test(item)) {
      return parseFloat(item);
    }
    return item;
  },

  set: (itemName, item) => {
    if (typeof item === "object") {
      sessionStorage.setItem(itemName, JSON.stringify(item));
    } else {
      sessionStorage.setItem(itemName, item);
    }
  },

  remove: itemName => {
    sessionStorage.removeItem(itemName);
  },

  removeMany: items => {
    items.forEach(item => {
      sessionStorage.removeItem(item);
    });
  },

  removeAll: () => {
    sessionStorage.clear();
  },
};

export default SessionStorage;
